import { ApolloClient, ApolloLink, InMemoryCache } from '@apollo/client';
import createUploadLink from 'apollo-upload-client/createUploadLink.mjs';
import { setContext } from '@apollo/client/link/context';
import environment from '@lib/environment';

import AuthModule from '../modules/AuthModule';
import { MockedResponse, MockLink } from '@apollo/client/testing';
import retryLink from './lib/retryLink';

const { API_URL } = environment;
export const MAX_RETRY_ATTEMPTS = 5;

const httpLink = createUploadLink({
  uri: ({ operationName }) => `${API_URL}/graphql?opname=${operationName}`,
  headers: { 'GraphQL-preflight': '1' },
});

const authLink = setContext(async (_, { headers }) => {
  const token = (await AuthModule.getCurrentToken()) || '';
  const serviceId = AuthModule.getCurrentServiceId();
  return {
    headers: {
      ...headers,
      'X-ContactCenter-Id': serviceId,
      authorization: token ? `Bearer ${token}` : '',
    },
  };
});

let globalMocks: readonly MockedResponse<any, any>[] | null = null;
export function setMocks(mocks: readonly MockedResponse<any, any>[] = []) {
  globalMocks = mocks;
}

const client = new ApolloClient({
  link: ApolloLink.from([authLink, retryLink(MAX_RETRY_ATTEMPTS), httpLink]),
  cache: createCache(),
});

export function getClient() {
  if (globalMocks) {
    return new ApolloClient({
      link: new MockLink(globalMocks, true).concat(httpLink),
      cache: createCache(),
    });
  }
  return client;
}

export function createCache() {
  return new InMemoryCache({
    typePolicies: {
      User: {
        keyFields: ['id'],
      },
      UserPersonalLine: {
        keyFields: false,
      },
      Address: {
        keyFields: false,
      },
      CallReason: {
        keyFields: ['id', 'tenantId'],
      },
    },
  });
}
